__webpack_require__.p = "/portfolio-dev/";